import { sortBy } from '@poseidon/shared-utils';
import React from 'react';

import { isNotNull } from '@harmonizeai/poseidon-shared';
import { Button, ButtonGroup, Select } from '@poseidon/components/Input2';
import { Arrows } from '@poseidon/components/StrokeIcons';

type OffsetPaginatorProps = {
  limit?: number;
  defaultLimit: number;
  // Upper bound on the page-size options (e.g. the backend's pagination `.max()`).
  // Options above it are filtered out so the selector can't produce a limit the
  // API rejects. Omit for no cap (default).
  maxLimit?: number;
  offset?: number;
  len?: number;
  onChange: (next: { limit?: number; offset?: number }) => void;
};
export const OffsetPaginator = ({ limit, defaultLimit, maxLimit, offset, len, onChange }: OffsetPaginatorProps) => {
  const limitDefined = limit ?? defaultLimit;

  const goNext =
    len == null || len >= limitDefined ? () => onChange({ limit, offset: (offset ?? 0) + limitDefined }) : undefined;
  const goPrev =
    offset != null && offset > 0 ? () => onChange({ limit, offset: Math.max(0, offset - limitDefined) }) : undefined;

  const options = React.useMemo(() => {
    return sortBy(
      Array.from(new Set([limit, defaultLimit, defaultLimit * 2, defaultLimit * 3].filter(isNotNull))).filter(
        (v) => maxLimit == null || v <= maxLimit,
      ),
    ).map((v) => ({ value: `${v}`, label: `${v}` }));
  }, [limit, defaultLimit, maxLimit]);

  return (
    <ButtonGroup size="sm">
      <Button icon={<Arrows.ArrowLeft />} onClick={goPrev} disabled={goPrev == null} />
      <Select
        className="min-w-16"
        placeholder="limit"
        options={options}
        value={`${limit || defaultLimit}`}
        onChange={(e) => onChange({ limit: Number.parseInt(e.target.value), offset: undefined })}
      />
      <Button icon={<Arrows.ArrowRight />} onClick={goNext} disabled={goNext == null} />
    </ButtonGroup>
  );
};
